import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { find } from 'lodash'

import { areSameValue } from '../../core/utils'

import { apolloService } from '../../common/services'

import { UPDATE_LOCATION_MUTATION } from '../graphql/mutations'
import { UPDATE_LOCATION } from '../redux/action-types'

const useUpdateLocationMutation = locationId => {
  const dispatch = useDispatch()

  const { isLoading, error } =
    useSelector(store =>
      find(store.locations.locations?.data?.result, ({ id }) =>
        areSameValue(id, locationId),
      ),
    ) || {}

  const mutate = useCallback(
    data =>
      apolloService.mutate({
        mutation: UPDATE_LOCATION_MUTATION,
        variables: { id: locationId, data },
        dispatch,
        action: UPDATE_LOCATION,
      }),
    [dispatch, locationId],
  )

  return [mutate, { isLoading, error }]
}

export default useUpdateLocationMutation
